import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { instoreLinkLoader as orgConfig } from 'org/configs/modules.config';

/** @type {object} */
const defaultConfig = {
  defaults: {
    animationLoader: {
      gif: null,
    },
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
